import { Button, Checkbox, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../../../components/Modals/SuccessfulModal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import * as Yup from "yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { createFestival, editFestival } from "../../../redux/festivalSlice";

const AddEditFestival = () => {
  const location = useLocation();
  const actionType = location.state?.actionType || "create";
  const festivalDetails = location.state?.festivalDetails || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [errorModalOpen, setErrorModelOpen] = useState(false);
  const [imageError, setImageError] = useState("");
  const { t } = useTranslation();

  const formInitialValues =
    actionType === "edit"
      ? {
          name: festivalDetails.name || "",
          startDate: dayjs(festivalDetails.startDate) || dayjs(),
          endDate: dayjs(festivalDetails.endDate) || dayjs(),
          description: festivalDetails.description || "",
        }
      : {
          name: "",
          startDate: dayjs(),
          endDate: dayjs(),
          description: "",
        };

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Festival name is required")
      .min(3, "Festival name should be at least 3 characters"),
    description: Yup.string().max(
      300,
      "Description cannot exceed 300 characters"
    ),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);

      let festivalData = {
        name: values.name,
        startDate: dayjs(values.startDate).format("YYYY-MM-DD"),
        endDate: dayjs(values.endDate).format("YYYY-MM-DD"),
        description: values.description,
      };

      // if (file) festivalData.image = file;
      console.log('====================================');
      console.log("DATA",festivalData);
      console.log('====================================');
      if (actionType === "edit") {
        const festivalId = festivalDetails._id;
        const response = await dispatch(
          editFestival({ festivalId, festivalData })
        );

        if (!response.payload.isSuccess) {
          throw new Error(response.payload.message || "Something went wrong");
        }
      } else {
        const response = await dispatch(createFestival(festivalData));

        if (!response.payload.isSuccess) {
          throw new Error(response.payload.message || "Internal Server Error");
        }
      }

      setSuccessModalOpen(true);
    } catch (error) {
      setErrorModelOpen(true);
      setImageError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="card mt-3">
                <div className="card-body m-3">
                  <div className="row">
                    {/* Festival Name */}
                    <div className="col-md-12 mb-3">
                      <TextField
                        label="Festival Name"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        fullWidth
                      />
                    </div>

                    {/* Start Date */}
                    <div className="col-md-4 mb-3">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="From Date*"
                          value={values.startDate}
                          onChange={(newValue) =>
                            setFieldValue("startDate", newValue)
                          }
                          slotProps={{
                            textField: {
                              error:
                                touched.startDate && Boolean(errors.startDate),
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* End Date */}
                    <div className="col-md-4 mb-3">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="To Date*"
                          value={values.endDate}
                          onChange={(newValue) =>
                            setFieldValue("endDate", newValue)
                          }
                          slotProps={{
                            textField: {
                              error: touched.endDate && Boolean(errors.endDate),
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* Description */}
                    <div className="col-md-12 mb-3">
                      <TextField
                        label="Festival Description"
                        name="description"
                        multiline
                        rows={4}
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.description && Boolean(errors.description)
                        }
                        helperText={`${values.description.length}/300`}
                        fullWidth
                        inputProps={{ maxLength: 300 }}
                      />
                    </div>

                    {/* Submit or Update Button */}
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate(-1)}
                      >
                        {t("createOrder.back")}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {actionType === "edit" ? "Update" : "Submit"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Success Modal */}
      {successModalOpen && (
        <SuccessModal
          isOpen={successModalOpen}
          msg={
            actionType === "edit"
              ? "Festival updated successfully"
              : "Festival created successfully"
          }
          navigatePage="/festival-list"
        />
      )}

      {/* Error Modal */}
      {errorModalOpen && (
        <SuccessModal isOpen={errorModalOpen} msg={imageError} type="error" />
      )}
    </>
  );
};

export default AddEditFestival;
